import { ad as getLookupValuePageTabs } from './index-e29b327a.js';
import { h as GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME } from './analytics-205f1857.js';
import { I as ECustomerType, J as QDS_ICON_PROPS, K as QDS_ICON_LIBRARIES } from './currency-7be6806c.js';

const OFFSET_PARAM_NAME = 'No';
const PRODUCTS_PER_PAGE_PARAM_NAME = 'Nrpp';
const NAVIGATION_STATE_PARAM_NAME = 'N';
const BUSINESS_ID_PARAM_NAME = 'businessId';
const SELECTED_NODE_ID = 'selected-node-id';
const DEFAULT_NAVIGATION_STATE = '726se132';

const updatePageLoadData = (params) => {
    const event = new CustomEvent(GLOBAL_PAGE_LOAD_UPDATE_EVENT_NAME, {
        detail: params,
        bubbles: true,
        composed: true,
    });
    window.dispatchEvent(event);
};
/**
 * Sets Query param if exists or removes from params if the value wasn't provided
 */
const setQueryParam = (searchParams, paramName, value) => {
    if (value) {
        searchParams.set(paramName, value);
    }
    else {
        searchParams.delete(paramName);
    }
};
function setPaginationParams(offset, nrpp, pushToHistory = false) {
    const searchParams = new URLSearchParams(window.location.search);
    setQueryParam(searchParams, OFFSET_PARAM_NAME, offset.toString());
    setQueryParam(searchParams, PRODUCTS_PER_PAGE_PARAM_NAME, nrpp.toString());
    if (pushToHistory) {
        window.history.pushState(null, '', `?${searchParams.toString()}${window.location.hash}`);
    }
    return searchParams;
}
const setArticleTitle = (articleTitle) => {
    updatePageLoadData({ articleTitle: getLookupValuePageTabs(articleTitle) });
};
const isAnalyticsEnabled = () => !window.analyticsDisabled;
/**
 * Returns cookie value or undefined if no cookie.
 */
const getCookie = (name) => {
    const regexp = new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`);
    const matches = document.cookie.match(regexp);
    return matches ? decodeURIComponent(matches[1]) : undefined;
};
const getUserSessionLoggedInValue = () => {
    return getCookie(ECustomerType.CLASSIFICATION1);
};
function getQdsIconLibrary(iconName) {
    var _a;
    return ((_a = QDS_ICON_PROPS[iconName]) === null || _a === void 0 ? void 0 : _a.library) || QDS_ICON_LIBRARIES.DEFAULT;
}
function setNonceToElement(element) {
    const anyElementWithNonce = document.querySelector('[nonce]');
    if (anyElementWithNonce) {
        element.setAttribute('nonce', anyElementWithNonce.getAttribute('nonce'));
    }
    else {
        console.warn('[PES]: Could not find any element with nonce attribute');
    }
}

export { BUSINESS_ID_PARAM_NAME as B, DEFAULT_NAVIGATION_STATE as D, NAVIGATION_STATE_PARAM_NAME as N, OFFSET_PARAM_NAME as O, PRODUCTS_PER_PAGE_PARAM_NAME as P, SELECTED_NODE_ID as S, setPaginationParams as a, setArticleTitle as b, getUserSessionLoggedInValue as c, getQdsIconLibrary as d, setNonceToElement as e, getCookie as g, isAnalyticsEnabled as i, setQueryParam as s, updatePageLoadData as u };
